// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"ActionPopup_buttonWrapper__K87u8","heading":"ActionPopup_heading__QyHoU"};